module.exports = __webpack_public_path__ + "static/media/icon-tuijian.09d494ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/icon-tuijian.png
// module id = 2020
// module chunks = 6